import {
  DefinitionActionKindEnum,
  DefinitionActionSubKindEnum,
} from '@acme/api';
import type { SendOfferFormData } from '@acme/domains';
import { ApplicationSendOfferForm, findAction } from '@acme/features';
import { BreadcrumbItem, Page } from '@acme/foundation';
import { $application } from '@entities/application';
import {
  $isSubmitting,
  applicationActionSucceeded,
  editApplicationRequested,
} from '@features/applicationActions';
import { actionResultShown } from '@widgets/applicationActions/model';
import { useUnit } from 'effector-react';
import { Card } from 'flowbite-react';
import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const SendOfferPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { application, onEditApplicationRequested, isSubmitting } = useUnit({
    application: $application,
    onEditApplicationRequested: editApplicationRequested,
    isSubmitting: $isSubmitting,
  });

  const actions = application?.actions ?? null;
  const formAction = useMemo(
    () =>
      findAction(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormEditApplication
      ),
    [actions]
  );

  useEffect(() => {
    const unsub = applicationActionSucceeded.watch(() => {
      if (!id) return;
      const app = $application.getState();
      const actions = app?.actions ?? null;
      const action = findAction(
        actions,
        DefinitionActionKindEnum.Form,
        DefinitionActionSubKindEnum.FormEditApplication
      );
      actionResultShown({
        isError: false,
        actionName: action?.name ?? 'Отправить предложение',
      });
      navigate(`/application/${id}`);
    });
    return () => unsub();
  }, [id, navigate]);

  const handleConfirm = useCallback(
    (data: SendOfferFormData) => {
      if (!formAction?.id || !id) return;
      console.log(data.files);
      onEditApplicationRequested({
        actionId: formAction.id,
        applicationId: id,
        contractUniqueNumber: data.contractUniqueNumber ?? '',
        tradeAgreementNumber: data.tradeAgreementNumber ?? '',
        files: data.files ?? [],
      });
    },
    [formAction?.id, id, onEditApplicationRequested]
  );

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Главная', onClick: () => navigate('/dashboard') },
    ...(application
      ? [
          {
            label: application.code ?? 'Заявка',
            onClick: () => navigate(`/application/${application.id}`),
          },
          { label: 'Отправить предложение' },
        ]
      : [{ label: 'Заявка не найдена' }]),
  ];

  return (
    <Page breadcrumbItems={breadcrumbItems}>
      <Card>
        <ApplicationSendOfferForm
          inline
          isSubmitting={isSubmitting}
          onConfirm={handleConfirm}
        />
      </Card>
    </Page>
  );
};
